<div *ngIf="spinner" class="spinner-container">
  <mat-spinner class="full-page-spinner"></mat-spinner>
</div>
<router-outlet></router-outlet> 